/* eslint-disable react/jsx-no-literals -- pre-i18n migration; replace literals with t() and remove this directive (see docs/i18n-migration-plan.md) */
import React from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '@hooks/useAuth';
import './GuestLayout.scss';
import logoImg from '@assets/images/vowsera_256x256.png';

const GuestLayout = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  const navItems = [
    { to: '/guest', icon: 'bi-house-heart', label: 'Home', end: true },
    { to: '/guest/rsvp', icon: 'bi-envelope-heart', label: 'RSVP' },
    { to: '/guest/schedule', icon: 'bi-calendar2-heart', label: 'Schedule' },
    { to: '/guest/travel', icon: 'bi-airplane', label: 'Travel & Stay' },
    { to: '/guest/registry', icon: 'bi-gift', label: 'Gift Registry' },
  ];

  return (
    <div className="guest-layout">
      {/* Elegant Top Bar */}
      <header className="guest-layout__header">
        <div className="guest-layout__header-inner">
          <div className="guest-layout__brand">
            <img src={logoImg} alt="VowsEra" className="guest-layout__logo" />
            <span className="guest-layout__brand-text">Wedding Guest</span>
          </div>

          <nav className="guest-layout__nav">
            {navItems.map(item => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.end}
                className={({ isActive }) => `guest-layout__nav-link ${isActive ? 'guest-layout__nav-link--active' : ''}`}
              >
                <i className={`bi ${item.icon}`}></i>
                <span>{item.label}</span>
              </NavLink>
            ))}
          </nav>

          <div className="guest-layout__user">
            <span className="guest-layout__user-name">{user?.first_name || 'Guest'}</span>
            <button onClick={handleLogout} className="guest-layout__logout">
              <i className="bi bi-box-arrow-right"></i>
            </button>
          </div>
        </div>
      </header>

      {/* Content */}
      <main className="guest-layout__main">
        <Outlet />
      </main>

      {/* Decorative Footer */}
      <footer className="guest-layout__footer">
        <span>Powered by VowsEra</span>
      </footer>
    </div>
  );
};

export default GuestLayout;
